import { render } from "./UpdateTaxRate.vue?vue&type=template&id=4f6e04a7&scoped=true&lang=pug"
import script from "./UpdateTaxRate.vue?vue&type=script&lang=js"
export * from "./UpdateTaxRate.vue?vue&type=script&lang=js"

import "./UpdateTaxRate.vue?vue&type=style&index=0&id=4f6e04a7&scoped=true&lang=scss"

import exportComponent from "/builds/wiwdata/applications/finance-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f6e04a7"]])

export default __exports__